<template>
  <div class="loader-wrapper">
    <ScaleLoader :loading="loading" :color="color"></ScaleLoader>
  </div>
</template>

<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

export default {
  name: 'loader',

  components: {
    ScaleLoader,
  },
  data() {
    return {
      color: '#10328f',
      loading: true,
    }
  },
}
</script>

<style lang="scss" scoped>
.loader-wrapper {
  @include flexMiddle;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
</style>
